# This gets automatically populated bij gulp

exports.date = 1493218703
exports.branch = "master"
exports.hash = "2c2404c"
exports.build = 2714
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee